import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqs } from '../../data/mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-amber-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-sky-500/5 rounded-full blur-3xl" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-sky-500/10 text-sky-400 text-sm font-medium mb-4">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Frequently Asked
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-amber-400">
              {' '}Questions
            </span>
          </h2>
          <p className="text-lg text-slate-400">
            Got questions? We&apos;ve got answers.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-slate-900/50 border border-slate-800 rounded-2xl px-6 data-[state=open]:border-sky-500/30 transition-colors"
            >
              <AccordionTrigger className="text-left text-lg font-medium text-white py-6 hover:no-underline hover:text-sky-400 transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <p className="text-slate-400">
            Still have questions?{' '}
            <a href="mailto:support@loadsurf.ai" className="text-sky-400 hover:underline font-medium">
              Contact our support team
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
